// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { TenantBaseApi } from "api/TenantSlug/TenantBaseApi.ts";

import GetConnectionSequenceStepsResponse = App.Http.Responses.ConnectionCreator.SequenceStep.GetConnectionSequenceStepsResponse;
import GetConnectionSequenceStepResponse = App.Http.Responses.ConnectionCreator.SequenceStep.GetConnectionSequenceStepResponse;
import StoreConnectionSequenceStepData = App.Http.Requests.ConnectionCreator.StoreConnectionSequenceStepData;

class ConnectionSequenceStepApi extends TenantBaseApi {
    async index(request): Promise<GetConnectionSequenceStepsResponse> {
        return await this.get<GetConnectionSequenceStepsResponse, unknown>("/connection-sequence-steps", {
            params: request,
        });
    }

    async show(stepId: string): Promise<GetConnectionSequenceStepResponse> {
        return await this.get<GetConnectionSequenceStepResponse, unknown>(`/connection-sequence-steps/${stepId}`);
    }

    async store(request: StoreConnectionSequenceStepData): Promise<GetConnectionSequenceStepResponse> {
        return await this.post<GetConnectionSequenceStepResponse, StoreConnectionSequenceStepData>(
            "/connection-sequence-steps",
            request
        );
    }

    async update(request: StoreConnectionSequenceStepData, stepId: string): Promise<GetConnectionSequenceStepResponse> {
        return await this.put<GetConnectionSequenceStepResponse, StoreConnectionSequenceStepData>(
            `/connection-sequence-steps/${stepId}`,
            request
        );
    }

    async destroy(stepId: string): Promise<void> {
        return await this.delete<void>(`/connection-sequence-steps/${stepId}`);
    }
}

export const connectionSequenceStepApi = new ConnectionSequenceStepApi();
